import React, { useEffect, useState } from "react";
import { Divider, InputNumber } from "antd";
import style from "./index.module.scss";
import { QuestionTypeCountList } from "service/answerStore";

interface RandomItemProps extends QuestionTypeCountList {
    onChange: (val: {
        typeId: string;
        typeCount: number; //总数
        counts: number; //手动选择的数目
        score: number;
    }) => void;
}

export default function RandomItem(props: RandomItemProps) {
    const { icon, typeCount, typeName, typeId, onChange, counts, score } =
        props;

    const [countItem, setCountItem] = useState<number>(counts);
    const [scoreItem, setScoreItem] = useState<number>(score);

    useEffect(() => {
        setCountItem(counts);
        setScoreItem(score);
    }, [counts, score]);

    useEffect(() => {
        onChange({
            typeId,
            typeCount,
            counts: countItem,
            score: scoreItem
        });
    }, [countItem, scoreItem]);

    return (
        <div className={style.RandomItem}>
            <img src={icon} alt="" />
            <span className={style.itemType}>{typeName}</span>

            <span>共{typeCount}题</span>
            <Divider className={style.itemDivider} type="vertical" />

            <span>抽取&nbsp;&nbsp;</span>
            <InputNumber
                value={countItem}
                min={0}
                max={typeCount}
                onChange={val => setCountItem(val || 0)}
            />

            <span>&nbsp;&nbsp;题</span>
            <Divider className={style.itemDivider} type="vertical" />

            <InputNumber
                precision={1}
                value={scoreItem}
                min={0.5}
                max={100}
                onChange={val => setScoreItem(val || 5)}
            />
            <span>&nbsp;&nbsp;分/题</span>
        </div>
    );
}
